import { connect } from "react-redux";
import { Dispatch } from "react";
import * as actions from "../redux/actions/RiderManagementActions";
import RiderManagementPage from "../components/pages/riderManagement/RiderManagementPage";
import {
  ICreateRiderRequestPayload,
  ICreateUpdateRiderRequestPayload,
} from "../interfaces/riderManagement.interface";
import {
  ICreateUpdateRiderManagementUserNormalizedReq,
  IGetQueryParams,
} from "../interfaces/Index";
import { fetchWareHouseNames } from "redux/actions/GlobalProductActions";

export const mapStateToProps = (state: any, props: any) => {
  return {
    riderTypes: state.riderManagement.riderTypes,
    isRiderManagementUserAdded:
      state.riderManagement.isRiderManagementUserAdded,
    isLoading: state.riderManagement.isLoading,
    isError: state.riderManagement.isError,
    error: state.riderManagement.error,
    isRiderListFetched: state.riderManagement.isRiderListFetched,
    pagination: state.riderManagement.pagination,
    riders: state.riderManagement.riders,
    riderUserDetails: state.riderManagement.riderUserDetails,
    isRiderUserDetailsFetched: state.riderManagement.isRiderListFetched,
    isRiderUpdated: state.riderManagement.isRiderUpdated,
    isRiderCreated: state.riderManagement.isRiderCreated,
    warehousesList: state.product.wareHouseNames,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    createRiderUser: (payload: ICreateUpdateRiderRequestPayload) =>
      dispatch(actions.createRiderUser(payload)),
    getRiderManagementList: (queryPrams?: IGetQueryParams) =>
      dispatch(actions.getRiderManagementList(queryPrams)),
    getRiderUserDetails: (id: string) =>
      dispatch(actions.getRiderUserDetailsAction(id)),
    updateRiderUser: (payload: ICreateUpdateRiderManagementUserNormalizedReq) =>
      dispatch(actions.updateRiderUser(payload)),
    createRider: (payload: ICreateRiderRequestPayload) =>
      dispatch(actions.createRider(payload)),
    getRiderJobTypes: () => dispatch(actions.getRiderJobTypesAction()),
    getWarehouses: () => dispatch(fetchWareHouseNames()),
  };
};

const RiderManagementContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RiderManagementPage);
export default RiderManagementContainer;
